import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ibm-aiops-training/ibm-aiops-training/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`📥 STEP: Connect to the DemoUI`}</h2>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`In your OpenShift Console click on the Applications Menu`}</p>
        <img parentName="li" {...{
          "src": "./../images/07_fzth_ocp_menu.png",
          "alt": "image"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Select `}<strong parentName="p">{`CP4AIOps Demo UI`}</strong></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Login with token `}<inlineCode parentName="p">{`P4ssw0rd!`}</inlineCode></p>
        <img parentName="li" {...{
          "src": "./../images/08_demo_ui_login.png",
          "alt": "image"
        }}></img>
      </li>
    </ol>
    <h2>{`📥 STEP: Trigger the incident`}</h2>
    <p><strong parentName="p">{`❗ `}<u>{`Note`}</u></strong>{`: The following step does not have to be shown to the client – you may perform the action in the background if possible.`}</p>
    <img {...{
      "src": "./../images/demo/image.054.png",
      "alt": "image"
    }}></img>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`🚀 `}<u>{`Action`}</u></strong>{`
Open AIManager `}<strong parentName="p">{`Demo`}</strong>{` UI, and trigger the incident`}</p>
      <ul parentName="blockquote">
        <li parentName="ul">
          <p parentName="li">{`Point your browser to the AIManager Demo UI, `}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Login with the token “P4ssw0rd!” and `}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Trigger the incident `}<inlineCode parentName="p">{`(3)`}</inlineCode>{` you would like to use in your demo. `}</p>
        </li>
      </ul>
      <p parentName="blockquote">{` This action injects the stream of simulated events into the system, which replicates what could happen in a real life situation.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      